import React, { useEffect, useState } from "react";
import logo from "../../assets/image/brand/logo.png"
import { login } from "services/http/Login";
import * as keys from "../../utils/constant";
import * as storage from '../../services/storage';
import toast from "react-hot-toast";
import { useDispatch } from 'react-redux';
import { setAuthData } from '../../redux/slice/index'
import { useLoader } from "services/loaderService";
import { useNavigate } from "react-router-dom";

const RedirectUser = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ name: "", password: "" });
  const { showLoader, hideLoader } = useLoader();
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();
    const payload = { name: formData.name, password: formData.password };
    try {
      let result = await login(payload);
      if (result?.response?.success) {
        const token = result?.response?.receiveObj?.data?.data?.token;
        const commonServiceToken = result?.response?.receiveObj?.data?.data?.commonServiceToken;
        const profile = result?.response?.receiveObj?.data?.data;

        if (token && profile) {
          storage.setLocalStorage(keys.STORAGE_AUTH_KEY, true);
          storage.setLocalStorage(keys.STORAGE_TOKEN_KEY, token);
          storage.setLocalStorage(keys.STORAGE_PROFILE_KEY, profile);
          storage.setLocalStorage(keys.COMMON_SERVICE_AUTH_TOKEN, commonServiceToken);

          dispatch(setAuthData({
            isAuthenticated: true,
            token,
            profile,
            commonServiceToken,
          }));

          hideLoader();
          navigate('/patientList'); // Change to attorney dashboard route
          return;
        } 
      }

      hideLoader();
      toast.error(result?.response?.receiveObj?.response?.data?.message || "Login failed");
    } catch (e) {
      hideLoader();
      toast.error('Something went wrong!');
      console.error(e);
    }
  };

  // ✅ Auto-login from cookies
  useEffect(() => {

  const deleteCookie = (name, domain) => {
    document.cookie =
      name +
      "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;" +
      (domain ? " domain=" + domain + ";" : "");
  };


    const attemptAutoLogin = async () => {
      const storedUsername = getCookie("_attorney_username");
      const storedPassword = getCookie("_attorney_password");

      if (storedUsername && storedPassword) {
        showLoader();
        let plainPassword = atob(storedPassword);
        setFormData({ name: storedUsername, password: plainPassword });
        // Trigger login after setting form data
        const payload = { showPassword: false, name: storedUsername, password: plainPassword };
        try {
          let result = await login(payload);
          if (result) {
        if (result?.response?.success) {
          const token = result?.response?.receiveObj?.data?.data?.token;
          const commonServiceToken =
            result?.response?.receiveObj?.data?.data?.commonServiceToken;
          const profile = result?.response?.receiveObj?.data?.data;
          if (result?.response?.success && token && profile) {
            storage.setLocalStorage(keys.STORAGE_AUTH_KEY, true);
            storage.setLocalStorage(keys.STORAGE_TOKEN_KEY, token);
            storage.setLocalStorage(keys.STORAGE_PROFILE_KEY, profile);
            storage.setLocalStorage(
              keys.COMMON_SERVICE_AUTH_TOKEN,
              commonServiceToken
            );
            // Dispatch Redux action
            dispatch(
              setAuthData({
                isAuthenticated: true,
                token,
                profile: profile,
                // userUid,
                commonServiceToken,
              })
            );
            hideLoader();
            // ✅ Delete cookies after successful login
            deleteCookie("_attorney_username");
            deleteCookie("_attorney_password");
            navigate('/patientList')
            // window.location.href = "/patientList";

            return {
              isAuthenticated: true,
              token: token,
              profile: profile,
              commonServiceToken: commonServiceToken,
            };

          }
        } else {
          hideLoader();
          toast.error(result?.response?.receiveObj?.response?.data?.message || result?.response?.receiveObj?.message);
          navigate('/');
        }
      } else {
        hideLoader();
        toast.error(result?.response?.receiveObj?.data?.message || "Something went wrong!");
        navigate('/');
      }
        } catch (e) {
          hideLoader();
          console.error("Auto-login error:", e);
        }
      }else{
        navigate('/');
      }
    };

    attemptAutoLogin();
    document.getElementById("attorney-username")?.focus();
  }, []);

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => !formData.name || !formData.password;

  return (
    <div className="flex items-center justify-center min-h-screen bg-cadetblue">
      <div className="w-80 max-w-md p-6 bg-white rounded-lg shadow-md">
        <div className="flex justify-center mb-6">
          <img src={logo} alt="Logo" className="header-brand-img1" />
        </div>
        <h2 className="text-center text-xl font-bold mb-6">Attorney Login</h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="attorney-username" className="sr-only">
              Username
            </label>
            <div className="flex items-center">
              <span className="mr-3">
                <i className="fa-solid fa-user"></i>
              </span>
              <input
                id="attorney-username"
                name="name"
                type="text"
                placeholder="Username"
                value={formData.name}
                onChange={handleTextChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-[rgb(95,158,160)]"
              />
            </div>
          </div>

          <div>
            <label htmlFor="attorney-password" className="sr-only">
              Password
            </label>
            <div className="flex items-center">
              <span onClick={() => setShowPassword(!showPassword)} className="cursor-pointer mr-2">
                {showPassword ? (
                  <i className="fa-solid fa-eye-slash"></i>
                ) : (
                  <i className="fa-solid fa-eye"></i>
                )}
              </span>
              <input
                id="attorney-password"
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={formData.password}
                onChange={handleTextChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-[rgb(95,158,160)]"
              />
            </div>
          </div>

          <div className="flex justify-center">
            <button
              type="submit"
              disabled={validateForm()}
              className="w-40 h-11 text-lg font-bold text-white bg-cadetblue rounded-lg hover:bg-cadetblue focus:outline-none focus:ring focus:ring-[rgb(95,158,160)] disabled:bg-gray-300"
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RedirectUser;